<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body d-flex_cus">
        <h1
          v-if="show"
          class="uppercase text-center mt-4 hello-text"
        >
          Xin chào "{{ fullName }}"
        </h1>
      </div>
    </div>
  </div>
</template>
<script>
import MethodService from '../../../service/MethodService'
import EmployeeApi from '../../../moduleApi/EmployeeApi'
import CompanyApi from '../../../moduleApi/CompanyApi'

export default {
  data() {
    return {
      show: false,
      currentUser: MethodService.getCurrentUser(),
      listFeatures: MethodService.getListFeatures(),
      fullName: '',
    }
  },
  methods: {
    async checkEmployeeAndFeatures() {
      const employeeApiRes = await EmployeeApi.findById(this.currentUser.id, true)
      const companyApiRes = await CompanyApi.findById(this.currentUser.id)

      if (this.currentUser.roles.includes('AdminSystem')) {
        this.fullName = 'Admin'
        this.show = true
      } else if (!employeeApiRes.result && companyApiRes.result) {
        this.fullName = companyApiRes.result.name.full_name
        this.$router.push({ name: 'Admin-Home' }).catch(() => {})
      } else {
        // this.fullName = 'Admin'
        // this.show = true
        this.$router.push({ name: 'Admin-Individual-Dashboard' })
        // if (this.listFeatures.includes('FT1402')) {
        //   this.$router.push({ name: 'Admin-Home-Employee' })
        // } else {
        //   let route = MethodService.getNavSubMenus()
        //   if (route && route.length > 0) {
        //     if (
        //       route[0].children &&
        //       route[0].children.length > 0 &&
        //       route[0].children[0].nameRoute
        //     ) {
        //       this.$router.push({ name: route[0].children[0].nameRoute })
        //     } else if (route[0].nameRoute) {
        //       this.$router.push({ name: route[0].nameRoute })
        //     }
        //   } else {
        //     if (
        //       employeeApiRes.result &&
        //       employeeApiRes.result.administrative_info &&
        //       employeeApiRes.result.administrative_info.name &&
        //       employeeApiRes.result.administrative_info.name.full_name
        //     ) {
        //       this.fullName = employeeApiRes.result.administrative_info.name.full_name
        //       setTimeout(() => {
        //         this.show = true
        //       }, 1000)
        //     }
        //   }
        // }
      }
    },
  },
  created() {
    this.checkEmployeeAndFeatures();
  },
};
</script>
<style scoped>
.d-flex_cus {
  display: flex;
  justify-content: center;
  align-items: top;
}
.hello-text {
  color: #0064b2;
  font-family: 'Times new roman';
  font-weight: bold;
  word-break: break-all;
  white-space: break-spaces;
}
/* .mt-7{
    margin-top: 5rem;
} */
</style>
